import { Stack } from "@mui/material";

interface SpaceBetweenProps extends React.ComponentProps<typeof Stack> {
  children: React.ReactNode;
}

const SpaceBetween: React.FC<SpaceBetweenProps> = ({
  children,
  ...innerProps
}) => {
  return (
    <Stack
      direction={["column", "row"]}
      justifyContent={["center", "space-between"]}
      alignItems="center"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...innerProps}
    >
      {children}
    </Stack>
  );
};

interface CenterProps extends React.ComponentProps<typeof Stack> {
  children: React.ReactNode;
}

const Center: React.FC<CenterProps> = ({ children, ...innerProps }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Stack justifyContent="center" alignItems="center" {...innerProps}>
      {children}
    </Stack>
  );
};

interface FlexEndProps extends React.ComponentProps<typeof Stack> {
  children: React.ReactNode;
}

const FlexEnd: React.FC<FlexEndProps> = ({ children, ...innerProps }) => {
  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...innerProps}
    >
      {children}
    </Stack>
  );
};

export default {
  SpaceBetween,
  Center,
  FlexEnd,
  Normal: Stack,
};
